// extracted by mini-css-extract-plugin
var _1 = "background__kEJKO";
var _2 = "crossButtonWrapper__vwUza";
var _3 = "header__W7e3v";
var _4 = "mobileFullSize__ucWbk";
var _5 = "modal__OqoNr";
var _6 = "title__pJ6R5";
export { _1 as "background", _2 as "crossButtonWrapper", _3 as "header", _4 as "mobileFullSize", _5 as "modal", _6 as "title" }
export default { "background": _1, "crossButtonWrapper": _2, "header": _3, "mobileFullSize": _4, "modal": _5, "title": _6 }
